"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.StudentHeader = exports.StudentHeaderDefaultArgs = void 0;
var get_component_1 = require("../../shared/helpers/get-component");
var il_student_header_1 = require("./il-student-header");
// arguments
exports.StudentHeaderDefaultArgs = {
    name: 'Max',
    avatar: 'BLUE',
    overdueText: 'Overdue',
    overdueNumber: 3,
    assignmentsText: 'Assignments',
    assignmentsNumber: 3,
};
// components
exports.StudentHeader = (0, get_component_1.getComponent)(il_student_header_1.IlStudentHeader, exports.StudentHeaderDefaultArgs);
